module.exports = function (a) {
    var guid = $(this).data('list-guid');
    var track_guid = $(this).data('guid');

    swal({
        title: 'Czy chcesz skasować tą propozycję?',
        type: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Kasuj',
        cancelButtonText: 'Anuluj',
        preConfirm: function () {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    type: "POST",
                    url: laroute.route('public::propositions::ajax::remove_propose', {'guid': track_guid}),
                    data: {
                        "_method": "delete",
                        list: guid,
                    }
                }).done(function (msg) {
                    if (msg.error) {
                        reject(msg.message);
                    }else{
                        resolve();
                    }
                }).error(function (msg) {console.log(msg);reject('ERROR');});
            })
        },
    }).then(
        function (inputValue) {
            $("#row_"+track_guid).remove();
            swal({
                title: 'Propozycja została skasowana.',
                type: "success"
            });
        },
        // handling the promise rejection
        function (dismiss) {}
    );
};